import type { Artwork } from "./types";

export const msPaintWorks: Artwork[] = [
  {
    id: "d1",
    title: "abstract 1",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/abstract-1.png",
    fullImage: "/gallery/msPaint/full/abstract 1.png",
    date: "2023-03-30",
  },
  {
    id: "d2",
    title: "abstract jewel tones",
    year: 2026,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/abstract-jewel-tones.png",
    fullImage: "/gallery/msPaint/full/abstract jewel tones.png",
    date: "2026-02-08",
  },
  {
    id: "d3",
    title: "alcohoball",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/alcohoball.png",
    fullImage: "/gallery/msPaint/full/alcohoball.png",
    date: "2025-05-19",
  },
  {
    id: "d4",
    title: "alexnotflawed",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/alexnotflawed.png",
    fullImage: "/gallery/msPaint/full/alexnotflawed.png",
    date: "2025-04-14",
  },
  {
    id: "d5",
    title: "alienworld",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/alienworld.png",
    fullImage: "/gallery/msPaint/full/alienworld.png",
    date: "2025-05-09",
  },
  {
    id: "d6",
    title: "amanda",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/amanda.png",
    fullImage: "/gallery/msPaint/full/amanda.png",
    date: "2022-10-27",
  },
  {
    id: "d7",
    title: "angelboy1",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/angelboy1.png",
    fullImage: "/gallery/msPaint/full/angelboy1.png",
    date: "2025-04-24",
  },
  {
    id: "d8",
    title: "angelgirl1",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/angelgirl1.png",
    fullImage: "/gallery/msPaint/full/angelgirl1.png",
    date: "2025-04-24",
  },
  {
    id: "d9",
    title: "angelthing 3",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/angelthing-3.png",
    fullImage: "/gallery/msPaint/full/angelthing 3.png",
    date: "2025-04-24",
  },
  {
    id: "d10",
    title: "angelthing 4",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/angelthing-4.png",
    fullImage: "/gallery/msPaint/full/angelthing 4.png",
    date: "2025-04-24",
  },
  {
    id: "d11",
    title: "apothecary",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/apothecary.png",
    fullImage: "/gallery/msPaint/full/apothecary.png",
    date: "2025-06-12",
  },
  {
    id: "d12",
    title: "asuka",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/asuka.png",
    fullImage: "/gallery/msPaint/full/asuka.png",
    date: "2025-05-16",
  },
  {
    id: "d13",
    title: "atlantis",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/atlantis.png",
    fullImage: "/gallery/msPaint/full/atlantis.png",
    date: "2025-11-03",
  },
  {
    id: "d14",
    title: "awkward hug",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/awkward-hug.png",
    fullImage: "/gallery/msPaint/full/awkward hug.png",
    date: "2022-11-12",
  },
  {
    id: "d15",
    title: "azure divinity, discomfort confidence",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/azure-divinity-discomfort-confidence.png",
    fullImage: "/gallery/msPaint/full/azure divinity, discomfort confidence.png",
    date: "2022-10-15",
  },
  {
    id: "d16",
    title: "barn",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/barn.png",
    fullImage: "/gallery/msPaint/full/barn.png",
    date: "2022-10-17",
  },
  {
    id: "d17",
    title: "beachday",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/beachday.png",
    fullImage: "/gallery/msPaint/full/beachday.png",
    date: "2025-05-28",
  },
  {
    id: "d18",
    title: "bear",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/bear.png",
    fullImage: "/gallery/msPaint/full/bear.png",
    date: "2025-05-16",
  },
  {
    id: "d19",
    title: "beggars cant be",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/beggars-cant-be.png",
    fullImage: "/gallery/msPaint/full/beggars cant be.png",
    date: "2023-02-18",
  },
  {
    id: "d20",
    title: "better safe than sorry",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/better-safe-than-sorry.png",
    fullImage: "/gallery/msPaint/full/better safe than sorry.png",
    date: "2023-02-05",
  },
  {
    id: "d21",
    title: "birth of amoebachan",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/birth-of-amoebachan.png",
    fullImage: "/gallery/msPaint/full/birth of amoebachan.png",
    date: "2025-05-03",
  },
  {
    id: "d22",
    title: "bobross",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/bobross.png",
    fullImage: "/gallery/msPaint/full/bobross.png",
    date: "2025-06-13",
  },
  {
    id: "d23",
    title: "bobross1",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/bobross1.png",
    fullImage: "/gallery/msPaint/full/bobross1.png",
    date: "2025-06-13",
  },
  {
    id: "d24",
    title: "bobross2",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/bobross2.png",
    fullImage: "/gallery/msPaint/full/bobross2.png",
    date: "2025-06-13",
  },
  {
    id: "d25",
    title: "bozohar",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/bozohar.png",
    fullImage: "/gallery/msPaint/full/bozohar.png",
    date: "2025-04-14",
  },
  {
    id: "d26",
    title: "bubblebee",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/bubblebee.png",
    fullImage: "/gallery/msPaint/full/bubblebee.png",
    date: "2025-09-22",
  },
  {
    id: "d27",
    title: "bugs at night",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/bugs-at-night.png",
    fullImage: "/gallery/msPaint/full/bugs at night.png",
    date: "2022-10-14",
  },
  {
    id: "d28",
    title: "bunbun",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/bunbun.png",
    fullImage: "/gallery/msPaint/full/bunbun.png",
    date: "2023-02-11",
  },
  {
    id: "d29",
    title: "bunnie",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/bunnie.png",
    fullImage: "/gallery/msPaint/full/bunnie.png",
    date: "2025-05-08",
  },
  {
    id: "d30",
    title: "catto gm",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/catto-gm.png",
    fullImage: "/gallery/msPaint/full/catto gm.png",
    date: "2025-04-24",
  },
  {
    id: "d31",
    title: "chiaki",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/chiaki.png",
    fullImage: "/gallery/msPaint/full/chiaki.png",
    date: "2025-05-02",
  },
  {
    id: "d32",
    title: "city",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/city.png",
    fullImage: "/gallery/msPaint/full/city.png",
    date: "2025-05-21",
  },
  {
    id: "d33",
    title: "clobb",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/clobb.png",
    fullImage: "/gallery/msPaint/full/clobb.png",
    date: "2023-06-20",
  },
  {
    id: "d34",
    title: "command centre of the universe",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/command-centre-of-the-universe.png",
    fullImage: "/gallery/msPaint/full/command centre of the universe.png",
    date: "2022-10-17",
  },
  {
    id: "d35",
    title: "corn",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/corn.png",
    fullImage: "/gallery/msPaint/full/corn.png",
    date: "2023-03-30",
  },
  {
    id: "d36",
    title: "cow",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/cow.png",
    fullImage: "/gallery/msPaint/full/cow.png",
    date: "2025-04-21",
  },
  {
    id: "d37",
    title: "crustacean eat stroopwafel",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/crustacean-eat-stroopwafel.png",
    fullImage: "/gallery/msPaint/full/crustacean eat stroopwafel.png",
    date: "2025-04-15",
  },
  {
    id: "d38",
    title: "cubone",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/cubone.png",
    fullImage: "/gallery/msPaint/full/cubone.png",
    date: "2025-04-22",
  },
  {
    id: "d39",
    title: "dear",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/dear.png",
    fullImage: "/gallery/msPaint/full/dear.png",
    date: "2025-11-24",
  },
  {
    id: "d40",
    title: "deathbyapathy",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/deathbyapathy.png",
    fullImage: "/gallery/msPaint/full/deathbyapathy.png",
    date: "2025-05-09",
  },
  {
    id: "d41",
    title: "dog and pony show",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/dog-and-pony-show.png",
    fullImage: "/gallery/msPaint/full/dog and pony show.png",
    date: "2023-02-08",
  },
  {
    id: "d42",
    title: "dolf",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/dolf.png",
    fullImage: "/gallery/msPaint/full/dolf.png",
    date: "2025-08-08",
  },
  {
    id: "d43",
    title: "don't forget",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/dont-forget.png",
    fullImage: "/gallery/msPaint/full/don't forget.png",
    date: "2025-06-29",
  },
  {
    id: "d44",
    title: "dont let her take you",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/dont-let-her-take-you.png",
    fullImage: "/gallery/msPaint/full/dont let her take you.png",
    date: "2022-06-13",
  },
  {
    id: "d45",
    title: "dontsmok",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/dontsmok.png",
    fullImage: "/gallery/msPaint/full/dontsmok.png",
    date: "2025-05-23",
  },
  {
    id: "d46",
    title: "dophin",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/dophin.png",
    fullImage: "/gallery/msPaint/full/dophin.png",
    date: "2025-09-20",
  },
  {
    id: "d47",
    title: "dragon isle",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/dragon-isle.png",
    fullImage: "/gallery/msPaint/full/dragon isle.png",
    date: "2022-10-27",
  },
  {
    id: "d48",
    title: "dropping like flies",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/dropping-like-flies.png",
    fullImage: "/gallery/msPaint/full/dropping like flies.png",
    date: "2023-02-18",
  },
  {
    id: "d49",
    title: "e-phermones",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/e-phermones.png",
    fullImage: "/gallery/msPaint/full/e-phermones.png",
    date: "2025-05-07",
  },
  {
    id: "d50",
    title: "eeke",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/eeke.png",
    fullImage: "/gallery/msPaint/full/eeke.png",
    date: "2022-06-17",
  },
  {
    id: "d51",
    title: "emily no scribbles",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/emily-no-scribbles.png",
    fullImage: "/gallery/msPaint/full/emily no scribbles.png",
    date: "2022-06-29",
  },
  {
    id: "d52",
    title: "end bullying",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/end-bullying.png",
    fullImage: "/gallery/msPaint/full/end bullying.png",
    date: "2025-05-19",
  },
  {
    id: "d53",
    title: "endless summer",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/endless-summer.png",
    fullImage: "/gallery/msPaint/full/endless summer.png",
    date: "2022-07-08",
  },
  {
    id: "d54",
    title: "eternal now",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/eternal-now.png",
    fullImage: "/gallery/msPaint/full/eternal now.png",
    date: "2025-04-24",
  },
  {
    id: "d55",
    title: "eternal sleep",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/eternal-sleep.png",
    fullImage: "/gallery/msPaint/full/eternal sleep.png",
    date: "2025-06-28",
  },
  {
    id: "d56",
    title: "eternal summer",
    year: 2024,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/eternal-summer.png",
    fullImage: "/gallery/msPaint/full/eternal summer.png",
    date: "2024-06-27",
  },
  {
    id: "d57",
    title: "eyes",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/eyes.png",
    fullImage: "/gallery/msPaint/full/eyes.png",
    date: "2022-10-21",
  },
  {
    id: "d58",
    title: "fall is here and so are you",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/fall-is-here-and-so-are-you.png",
    fullImage: "/gallery/msPaint/full/fall is here and so are you.png",
    date: "2022-08-31",
  },
  {
    id: "d59",
    title: "finding a seat in a crowded room",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/finding-a-seat-in-a-crowded-room.png",
    fullImage: "/gallery/msPaint/full/finding a seat in a crowded room.png",
    date: "2023-03-04",
  },
  {
    id: "d60",
    title: "fire cat",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/fire-cat.png",
    fullImage: "/gallery/msPaint/full/fire cat.png",
    date: "2022-11-12",
  },
  {
    id: "d61",
    title: "firegoddess2",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/firegoddess2.png",
    fullImage: "/gallery/msPaint/full/firegoddess2.png",
    date: "2025-05-10",
  },
  {
    id: "d62",
    title: "fishy",
    year: 2024,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/fishy.png",
    fullImage: "/gallery/msPaint/full/fishy.png",
    date: "2024-12-10",
  },
  {
    id: "d63",
    title: "flash on a screen",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/flash-on-a-screen.png",
    fullImage: "/gallery/msPaint/full/flash on a screen.png",
    date: "2025-05-06",
  },
  {
    id: "d64",
    title: "forbidden love",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/forbidden-love.png",
    fullImage: "/gallery/msPaint/full/forbidden love.png",
    date: "2022-10-21",
  },
  {
    id: "d65",
    title: "fortuna major",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/fortuna-major.png",
    fullImage: "/gallery/msPaint/full/fortuna major.png",
    date: "2025-06-11",
  },
  {
    id: "d66",
    title: "freewheelincw",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/freewheelincw.png",
    fullImage: "/gallery/msPaint/full/freewheelincw.png",
    date: "2025-06-02",
  },
  {
    id: "d67",
    title: "gamerfinal",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/gamerfinal.png",
    fullImage: "/gallery/msPaint/full/gamerfinal.png",
    date: "2025-02-25",
  },
  {
    id: "d68",
    title: "goddns",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/goddns.png",
    fullImage: "/gallery/msPaint/full/goddns.png",
    date: "2022-11-02",
  },
  {
    id: "d69",
    title: "goose",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/goose.png",
    fullImage: "/gallery/msPaint/full/goose.png",
    date: "2023-03-08",
  },
  {
    id: "d70",
    title: "grim reaper in a ghillie",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/grim-reaper-in-a-ghillie.png",
    fullImage: "/gallery/msPaint/full/grim reaper in a ghillie.png",
    date: "2025-04-12",
  },
  {
    id: "d71",
    title: "hatman",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/hatman.png",
    fullImage: "/gallery/msPaint/full/hatman.png",
    date: "2025-04-17",
  },
  {
    id: "d72",
    title: "head smashed in buffalo jump",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/head-smashed-in-buffalo-jump.png",
    fullImage: "/gallery/msPaint/full/head smashed in buffalo jump.png",
    date: "2023-03-03",
  },
  {
    id: "d73",
    title: "hedge",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/hedge.png",
    fullImage: "/gallery/msPaint/full/hedge.png",
    date: "2025-06-15",
  },
  {
    id: "d74",
    title: "hedges",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/hedges.png",
    fullImage: "/gallery/msPaint/full/hedges.png",
    date: "2022-11-06",
  },
  {
    id: "d75",
    title: "hello little friend",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/hello-little-friend.png",
    fullImage: "/gallery/msPaint/full/hello little friend.png",
    date: "2022-07-25",
  },
  {
    id: "d76",
    title: "horses in rehab",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/horses-in-rehab.png",
    fullImage: "/gallery/msPaint/full/horses in rehab.png",
    date: "2025-06-26",
  },
  {
    id: "d77",
    title: "huge cruise ship",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/huge-cruise-ship.png",
    fullImage: "/gallery/msPaint/full/huge cruise ship.png",
    date: "2022-10-14",
  },
  {
    id: "d78",
    title: "i live",
    year: 2024,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/i-live.png",
    fullImage: "/gallery/msPaint/full/i live.png",
    date: "2024-01-19",
  },
  {
    id: "d79",
    title: "i love u",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/i-love-u.png",
    fullImage: "/gallery/msPaint/full/i love u.png",
    date: "2022-10-17",
  },
  {
    id: "d80",
    title: "idaho murders",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/idaho-murders.png",
    fullImage: "/gallery/msPaint/full/idaho murders.png",
    date: "2022-12-31",
  },
  {
    id: "d81",
    title: "idk",
    year: 2026,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/idk.png",
    fullImage: "/gallery/msPaint/full/idk.png",
    date: "2026-01-17",
  },
  {
    id: "d82",
    title: "ignorant gambler",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/ignorant-gambler.png",
    fullImage: "/gallery/msPaint/full/ignorant gambler.png",
    date: "2023-02-22",
  },
  {
    id: "d83",
    title: "improving",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/improving.png",
    fullImage: "/gallery/msPaint/full/improving.png",
    date: "2025-05-09",
  },
  {
    id: "d84",
    title: "in my restless",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/in-my-restless.png",
    fullImage: "/gallery/msPaint/full/in my restless.png",
    date: "2025-11-04",
  },
  {
    id: "d85",
    title: "jantor",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/jantor.png",
    fullImage: "/gallery/msPaint/full/jantor.png",
    date: "2022-10-14",
  },
  {
    id: "d86",
    title: "joshua graham",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/joshua-graham.png",
    fullImage: "/gallery/msPaint/full/joshua graham.png",
    date: "2025-07-27",
  },
  {
    id: "d87",
    title: "just a drop in a bucket",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/just-a-drop-in-a-bucket.png",
    fullImage: "/gallery/msPaint/full/just a drop in a bucket.png",
    date: "2023-02-08",
  },
  {
    id: "d88",
    title: "kingdom",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/kingdom.png",
    fullImage: "/gallery/msPaint/full/kingdom.png",
    date: "2025-07-26",
  },
  {
    id: "d89",
    title: "kitty",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/kitty.png",
    fullImage: "/gallery/msPaint/full/kitty.png",
    date: "2025-05-20",
  },
  {
    id: "d90",
    title: "knowas",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/knowas.png",
    fullImage: "/gallery/msPaint/full/knowas.png",
    date: "2025-06-27",
  },
  {
    id: "d91",
    title: "lady bug",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/lady-bug.png",
    fullImage: "/gallery/msPaint/full/lady bug.png",
    date: "2022-10-14",
  },
  {
    id: "d92",
    title: "lets all love lain",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/lets-all-love-lain.png",
    fullImage: "/gallery/msPaint/full/lets all love lain.png",
    date: "2025-06-09",
  },
  {
    id: "d93",
    title: "lilguy",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/lilguy.png",
    fullImage: "/gallery/msPaint/full/lilguy.png",
    date: "2025-04-26",
  },
  {
    id: "d94",
    title: "limmy",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/limmy.png",
    fullImage: "/gallery/msPaint/full/limmy.png",
    date: "2022-07-09",
  },
  {
    id: "d95",
    title: "magical sidekick who fits in your pocket or backpack",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/magical-sidekick-who-fits-in-your-pocket-or-backpack.png",
    fullImage: "/gallery/msPaint/full/magical sidekick who fits in your pocket or backpack.png",
    date: "2025-05-15",
  },
  {
    id: "d96",
    title: "magicalxdeer",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/magicalxdeer.png",
    fullImage: "/gallery/msPaint/full/magicalxdeer.png",
    date: "2025-05-20",
  },
  {
    id: "d97",
    title: "maxwell",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/maxwell.png",
    fullImage: "/gallery/msPaint/full/maxwell.png",
    date: "2025-01-23",
  },
  {
    id: "d98",
    title: "meat",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/meat.png",
    fullImage: "/gallery/msPaint/full/meat.png",
    date: "2022-10-26",
  },
  {
    id: "d99",
    title: "meow",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/meow.png",
    fullImage: "/gallery/msPaint/full/meow.png",
    date: "2022-10-14",
  },
  {
    id: "d100",
    title: "mf paint",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/mf-paint.png",
    fullImage: "/gallery/msPaint/full/mf paint.png",
    date: "2023-01-07",
  },
  {
    id: "d101",
    title: "mfw",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/mfw.png",
    fullImage: "/gallery/msPaint/full/mfw.png",
    date: "2025-05-20",
  },
  {
    id: "d102",
    title: "MGTOW",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/mgtow.png",
    fullImage: "/gallery/msPaint/full/MGTOW.png",
    date: "2022-07-26",
  },
  {
    id: "d103",
    title: "mmmmmmm",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/mmmmmmm.png",
    fullImage: "/gallery/msPaint/full/mmmmmmm.png",
    date: "2025-09-30",
  },
  {
    id: "d104",
    title: "monsta",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/monsta.jpg",
    fullImage: "/gallery/msPaint/full/monsta.jpg",
    date: "2025-01-10",
  },
  {
    id: "d105",
    title: "moon wip",
    year: 2024,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/moon-wip.png",
    fullImage: "/gallery/msPaint/full/moon wip.png",
    date: "2024-12-05",
  },
  {
    id: "d106",
    title: "mrburns",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/mrburns.png",
    fullImage: "/gallery/msPaint/full/mrburns.png",
    date: "2025-04-26",
  },
  {
    id: "d107",
    title: "ms paint art",
    year: 2026,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/ms-paint-art.png",
    fullImage: "/gallery/msPaint/full/ms paint art.png",
    date: "2026-01-30",
  },
  {
    id: "d108",
    title: "multiple potions",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/multiple-potions.png",
    fullImage: "/gallery/msPaint/full/multiple potions.png",
    date: "2022-10-14",
  },
  {
    id: "d109",
    title: "my desk",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/my-desk.png",
    fullImage: "/gallery/msPaint/full/my desk.png",
    date: "2023-03-26",
  },
  {
    id: "d110",
    title: "normal distribution",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/normal-distribution.png",
    fullImage: "/gallery/msPaint/full/normal distribution.png",
    date: "2025-10-28",
  },
  {
    id: "d111",
    title: "notsee",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/notsee.png",
    fullImage: "/gallery/msPaint/full/notsee.png",
    date: "2025-05-21",
  },
  {
    id: "d112",
    title: "nuclear power plant",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/nuclear-power-plant.png",
    fullImage: "/gallery/msPaint/full/nuclear power plant.png",
    date: "2022-10-20",
  },
  {
    id: "d113",
    title: "nurse2_2",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/nurse2-2.png",
    fullImage: "/gallery/msPaint/full/nurse2_2.png",
    date: "2025-04-14",
  },
  {
    id: "d114",
    title: "one love",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/one-love.png",
    fullImage: "/gallery/msPaint/full/one love.png",
    date: "2025-04-22",
  },
  {
    id: "d115",
    title: "opportunistic thief",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/opportunistic-thief.png",
    fullImage: "/gallery/msPaint/full/opportunistic thief.png",
    date: "2025-05-15",
  },
  {
    id: "d116",
    title: "out like a light",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/out-like-a-light.png",
    fullImage: "/gallery/msPaint/full/out like a light.png",
    date: "2023-02-05",
  },
  {
    id: "d117",
    title: "paint yourself into a corner",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/paint-yourself-into-a-corner.png",
    fullImage: "/gallery/msPaint/full/paint yourself into a corner.png",
    date: "2023-02-18",
  },
  {
    id: "d118",
    title: "pangeastrong",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/pangeastrong.png",
    fullImage: "/gallery/msPaint/full/pangeastrong.png",
    date: "2025-04-27",
  },
  {
    id: "d119",
    title: "peace",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/peace.png",
    fullImage: "/gallery/msPaint/full/peace.png",
    date: "2025-04-24",
  },
  {
    id: "d120",
    title: "peasant warrior king",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/peasant-warrior-king.png",
    fullImage: "/gallery/msPaint/full/peasant warrior king.png",
    date: "2022-10-17",
  },
  {
    id: "d121",
    title: "people who have secrets",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/people-who-have-secrets.png",
    fullImage: "/gallery/msPaint/full/people who have secrets.png",
    date: "2023-03-25",
  },
  {
    id: "d122",
    title: "pepe1",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/pepe1.png",
    fullImage: "/gallery/msPaint/full/pepe1.png",
    date: "2025-04-24",
  },
  {
    id: "d123",
    title: "pepe2",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/pepe2.png",
    fullImage: "/gallery/msPaint/full/pepe2.png",
    date: "2025-05-02",
  },
  {
    id: "d124",
    title: "pepe3",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/pepe3.png",
    fullImage: "/gallery/msPaint/full/pepe3.png",
    date: "2025-05-09",
  },
  {
    id: "d125",
    title: "phalnger orientalis",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/phalnger-orientalis.png",
    fullImage: "/gallery/msPaint/full/phalnger orientalis.png",
    date: "2022-10-24",
  },
  {
    id: "d126",
    title: "piece of my mind",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/piece-of-my-mind.png",
    fullImage: "/gallery/msPaint/full/piece of my mind.png",
    date: "2023-02-05",
  },
  {
    id: "d127",
    title: "pink clouds",
    year: 2024,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/pink-clouds.png",
    fullImage: "/gallery/msPaint/full/pink clouds.png",
    date: "2024-12-29",
  },
  {
    id: "d128",
    title: "plant with a tongue",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/plant-with-a-tongue.png",
    fullImage: "/gallery/msPaint/full/plant with a tongue.png",
    date: "2023-03-03",
  },
  {
    id: "d129",
    title: "platos cave",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/platos-cave.png",
    fullImage: "/gallery/msPaint/full/platos cave.png",
    date: "2022-10-24",
  },
  {
    id: "d130",
    title: "plush couch with fish",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/plush-couch-with-fish.png",
    fullImage: "/gallery/msPaint/full/plush couch with fish.png",
    date: "2023-03-25",
  },
  {
    id: "d131",
    title: "primordial soup",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/primordial-soup.png",
    fullImage: "/gallery/msPaint/full/primordial soup.png",
    date: "2025-04-14",
  },
  {
    id: "d132",
    title: "puff puff",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/puff-puff.png",
    fullImage: "/gallery/msPaint/full/puff puff.png",
    date: "2025-04-24",
  },
  {
    id: "d133",
    title: "pukeirlpng",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/pukeirlpng.png",
    fullImage: "/gallery/msPaint/full/pukeirlpng.png",
    date: "2025-04-14",
  },
  {
    id: "d134",
    title: "puppy",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/puppy.png",
    fullImage: "/gallery/msPaint/full/puppy.png",
    date: "2025-04-11",
  },
  {
    id: "d135",
    title: "rats wearing",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/rats-wearing.png",
    fullImage: "/gallery/msPaint/full/rats wearing.png",
    date: "2025-05-20",
  },
  {
    id: "d136",
    title: "reindeer learning to fly",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/reindeer-learning-to-fly.png",
    fullImage: "/gallery/msPaint/full/reindeer learning to fly.png",
    date: "2022-11-12",
  },
  {
    id: "d137",
    title: "reptillian",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/reptillian.png",
    fullImage: "/gallery/msPaint/full/reptillian.png",
    date: "2025-04-15",
  },
  {
    id: "d138",
    title: "rimworld1",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/rimworld1.png",
    fullImage: "/gallery/msPaint/full/rimworld1.png",
    date: "2025-06-09",
  },
  {
    id: "d139",
    title: "roomie",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/roomie.png",
    fullImage: "/gallery/msPaint/full/roomie.png",
    date: "2025-04-21",
  },
  {
    id: "d140",
    title: "rough around the edges",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/rough-around-the-edges.png",
    fullImage: "/gallery/msPaint/full/rough around the edges.png",
    date: "2023-02-05",
  },
  {
    id: "d141",
    title: "ruffled feathers",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/ruffled-feathers.png",
    fullImage: "/gallery/msPaint/full/ruffled feathers.png",
    date: "2023-02-08",
  },
  {
    id: "d142",
    title: "scum of the earth",
    year: 2024,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/scum-of-the-earth.png",
    fullImage: "/gallery/msPaint/full/scum of the earth.png",
    date: "2024-12-14",
  },
  {
    id: "d143",
    title: "sea",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/sea.png",
    fullImage: "/gallery/msPaint/full/sea.png",
    date: "2022-11-20",
  },
  {
    id: "d144",
    title: "selling lemonade",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/selling-lemonade.png",
    fullImage: "/gallery/msPaint/full/selling lemonade.png",
    date: "2025-07-02",
  },
  {
    id: "d145",
    title: "severe engineer",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/severe-engineer.png",
    fullImage: "/gallery/msPaint/full/severe engineer.png",
    date: "2025-05-01",
  },
  {
    id: "d146",
    title: "sizzly",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/sizzly.png",
    fullImage: "/gallery/msPaint/full/sizzly.png",
    date: "2025-04-11",
  },
  {
    id: "d147",
    title: "spider",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/spider.png",
    fullImage: "/gallery/msPaint/full/spider.png",
    date: "2025-05-09",
  },
  {
    id: "d148",
    title: "spikey purple boy",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/spikey-purple-boy.png",
    fullImage: "/gallery/msPaint/full/spikey purple boy.png",
    date: "2025-05-09",
  },
  {
    id: "d149",
    title: "staggeringly ugly succubus",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/staggeringly-ugly-succubus.png",
    fullImage: "/gallery/msPaint/full/staggeringly ugly succubus.png",
    date: "2022-10-14",
  },
  {
    id: "d150",
    title: "superhero",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/superhero.png",
    fullImage: "/gallery/msPaint/full/superhero.png",
    date: "2022-11-20",
  },
  {
    id: "d151",
    title: "sweet communist text",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/sweet-communist-text.png",
    fullImage: "/gallery/msPaint/full/sweet communist text.png",
    date: "2025-05-06",
  },
  {
    id: "d152",
    title: "swirlies",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/swirlies.png",
    fullImage: "/gallery/msPaint/full/swirlies.png",
    date: "2022-10-15",
  },
  {
    id: "d153",
    title: "take care",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/take-care.png",
    fullImage: "/gallery/msPaint/full/take care.png",
    date: "2022-07-11",
  },
  {
    id: "d154",
    title: "tamagotchi monkey and pygmy marmoset",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/tamagotchi-monkey-and-pygmy-marmoset.png",
    fullImage: "/gallery/msPaint/full/tamagotchi monkey and pygmy marmoset.png",
    date: "2025-04-13",
  },
  {
    id: "d155",
    title: "thats amore",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/thats-amore.png",
    fullImage: "/gallery/msPaint/full/thats amore.png",
    date: "2022-07-10",
  },
  {
    id: "d156",
    title: "the more the merrier",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/the-more-the-merrier.png",
    fullImage: "/gallery/msPaint/full/the more the merrier.png",
    date: "2022-10-16",
  },
  {
    id: "d157",
    title: "think",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/think.png",
    fullImage: "/gallery/msPaint/full/think.png",
    date: "2023-02-11",
  },
  {
    id: "d158",
    title: "throat hell",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/throat-hell.png",
    fullImage: "/gallery/msPaint/full/throat hell.png",
    date: "2023-02-22",
  },
  {
    id: "d159",
    title: "tim",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/tim.png",
    fullImage: "/gallery/msPaint/full/tim.png",
    date: "2022-11-02",
  },
  {
    id: "d160",
    title: "treefrog",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/treefrog.png",
    fullImage: "/gallery/msPaint/full/treefrog.png",
    date: "2025-05-08",
  },
  {
    id: "d161",
    title: "trees at night",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/trees-at-night.png",
    fullImage: "/gallery/msPaint/full/trees at night.png",
    date: "2022-10-16",
  },
  {
    id: "d162",
    title: "twink",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/twink.png",
    fullImage: "/gallery/msPaint/full/twink.png",
    date: "2022-10-27",
  },
  {
    id: "d163",
    title: "two morons",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/two-morons.png",
    fullImage: "/gallery/msPaint/full/two morons.png",
    date: "2023-03-25",
  },
  {
    id: "d164",
    title: "Untitled",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/untitled.png",
    fullImage: "/gallery/msPaint/full/Untitled.png",
    date: "2022-10-16",
  },
  {
    id: "d165",
    title: "uwu",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/uwu.png",
    fullImage: "/gallery/msPaint/full/uwu.png",
    date: "2025-09-20",
  },
  {
    id: "d166",
    title: "vamp",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/vamp.png",
    fullImage: "/gallery/msPaint/full/vamp.png",
    date: "2022-11-02",
  },
  {
    id: "d167",
    title: "veteran demon hunter",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/veteran-demon-hunter.png",
    fullImage: "/gallery/msPaint/full/veteran demon hunter.png",
    date: "2022-11-02",
  },
  {
    id: "d168",
    title: "vex",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/vex.png",
    fullImage: "/gallery/msPaint/full/vex.png",
    date: "2025-05-16",
  },
  {
    id: "d169",
    title: "when the teacher is readu",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/when-the-teacher-is-readu.png",
    fullImage: "/gallery/msPaint/full/when the teacher is readu.png",
    date: "2023-03-21",
  },
  {
    id: "d170",
    title: "where blocked messages go",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/where-blocked-messages-go.png",
    fullImage: "/gallery/msPaint/full/where blocked messages go.png",
    date: "2022-07-09",
  },
  {
    id: "d171",
    title: "wipo",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/wipo.png",
    fullImage: "/gallery/msPaint/full/wipo.png",
    date: "2022-07-08",
  },
  {
    id: "d172",
    title: "wizard money lizard gang",
    year: 2023,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/wizard-money-lizard-gang.png",
    fullImage: "/gallery/msPaint/full/wizard money lizard gang.png",
    date: "2023-03-25",
  },
  {
    id: "d173",
    title: "woman",
    year: 2026,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/woman.png",
    fullImage: "/gallery/msPaint/full/woman.png",
    date: "2026-02-09",
  },
  {
    id: "d174",
    title: "yoar gay",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/yoar-gay.png",
    fullImage: "/gallery/msPaint/full/yoar gay.png",
    date: "2025-05-20",
  },
  {
    id: "d175",
    title: "you didnt",
    year: 2022,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/you-didnt.png",
    fullImage: "/gallery/msPaint/full/you didnt.png",
    date: "2022-06-25",
  },
  {
    id: "d176",
    title: "you tleling mea",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/you-tleling-mea.png",
    fullImage: "/gallery/msPaint/full/you tleling mea.png",
    date: "2025-05-20",
  },
  {
    id: "d177",
    title: "you wide eyed girls",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/you-wide-eyed-girls.png",
    fullImage: "/gallery/msPaint/full/you wide eyed girls.png",
    date: "2025-04-15",
  },
  {
    id: "d178",
    title: "youcantbreak",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/youcantbreak.png",
    fullImage: "/gallery/msPaint/full/youcantbreak.png",
    date: "2025-04-14",
  },
  {
    id: "d179",
    title: "zappy",
    year: 2025,
    medium: "MS Paint Art",
    thumbnail: "/gallery/msPaint/thumbs/zappy.png",
    fullImage: "/gallery/msPaint/full/zappy.png",
    date: "2025-02-26",
  },
];
